import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const VirtualTourModal = ({ property, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
      <div className="bg-slate-900 border border-white/10 rounded-3xl shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-4 md:p-6 border-b border-white/10">
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-white">
              Visite virtuelle 360°
            </h2>
            <p className="text-sm text-slate-400 mt-1">{property?.title}</p>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-full hover:bg-slate-800 flex items-center justify-center transition-colors"
            aria-label="Close virtual tour"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <div className="flex-1 overflow-auto p-4 md:p-6">
          <div className="aspect-video bg-slate-800 rounded-lg overflow-hidden mb-6">
            <iframe
              width="100%"
              height="100%"
              loading="lazy"
              title={`Virtual tour of ${property?.title}`}
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps?q=${property?.coordinates?.lat},${property?.coordinates?.lng}&z=18&output=embed&layer=c&cbll=${property?.coordinates?.lat},${property?.coordinates?.lng}`}
              className="w-full h-full"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-slate-800/50 rounded-lg p-4">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 rounded-full bg-blue-500/10 flex items-center justify-center">
                  <Icon name="Home" size={20} className="text-blue-400" />
                </div>
                <div>
                  <p className="text-sm text-slate-400">Type</p>
                  <p className="font-semibold text-white">{property?.type}</p>
                </div>
              </div>
            </div>

            <div className="bg-slate-800/50 rounded-lg p-4">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 rounded-full bg-amber-500/10 flex items-center justify-center">
                  <Icon name="Maximize" size={20} className="text-amber-400" />
                </div>
                <div>
                  <p className="text-sm text-slate-400">Surface</p>
                  <p className="font-semibold text-white">{property?.area} m²</p>
                </div>
              </div>
            </div>

            <div className="bg-slate-800/50 rounded-lg p-4">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 rounded-full bg-green-500/10 flex items-center justify-center">
                  <Icon name="DollarSign" size={20} className="text-green-400" />
                </div>
                <div>
                  <p className="text-sm text-slate-400">Prix</p>
                  <p className="font-semibold text-white">{property?.price?.toLocaleString('fr-FR')} CDF</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 p-4 bg-blue-500/10 rounded-lg border border-blue-500/20">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={20} className="text-blue-400 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-white mb-1">
                  Navigation de la visite virtuelle
                </p>
                <p className="text-sm text-slate-400">
                  Utilisez votre souris ou vos doigts pour explorer la propriété en 360°. Cliquez et faites glisser pour regarder autour de vous.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="p-4 md:p-6 border-t border-white/10 flex gap-3">
          <Button
            variant="outline"
            iconName="MessageCircle"
            iconPosition="left"
            onClick={() => {
              const message = encodeURIComponent(`Je souhaite planifier une visite pour ${property?.title}`);
              window.open(`https://wa.me/243818883531?text=${message}`, '_blank');
            }}
            className="flex-1"
          >
            Planifier visite
          </Button>
          <Button
            variant="default"
            iconName="Phone"
            iconPosition="left"
            onClick={onClose}
            className="flex-1"
          >
            Contacter agent
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VirtualTourModal;
